export default "__VITE_ASSET__Bnxzf_Te__"